var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTipsCollapse = function SvgTipsCollapse(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m10.316 6.262-1.41 1.41 4.58 4.59-4.58 4.59 1.41 1.41 6-6-6-6Z",
    fill: "#000"
  })));
};
export default SvgTipsCollapse;